import { topicItems } from '@/mocks/homeData';

export default function TopicsSection() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <div className="inline-flex items-center gap-2 px-3 py-1 rounded-full bg-primary-100/80 mb-4">
            <i className="ri-hashtag text-primary-600 text-sm"></i>
            <span className="text-primary-700 text-xs font-medium">热门话题</span>
          </div>
          <h2 className="font-heading text-2xl md:text-4xl font-black text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base max-w-lg mx-auto">
            当前站内最热的十大话题，点击加入吃瓜讨论
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {topicItems.map((item) => (
            <div
              key={item.id}
              className="group inline-flex items-center gap-3 px-4 py-3 rounded-xl bg-background-50 border border-background-200/70 transition-all duration-200 hover:border-primary-300 hover:-translate-y-0.5 cursor-pointer"
            >
              <div className="w-9 h-9 rounded-lg bg-primary-100 flex items-center justify-center flex-shrink-0">
                <i className={`${item.icon} text-primary-600 text-base`}></i>
              </div>
              <div>
                <div className="flex items-center gap-1.5">
                  <span className="font-bold text-sm text-foreground-900 group-hover:text-primary-600 transition-colors">
                    {item.name}
                  </span>
                  {item.trend === 'up' ? (
                    <i className="ri-arrow-up-line text-accent-500 text-xs"></i>
                  ) : (
                    <i className="ri-arrow-down-line text-secondary-400 text-xs"></i>
                  )}
                </div>
                <span className="text-xs text-foreground-400">{item.heat} 热度</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}